import { useFormik } from "formik";
import Model from "../Model";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import Loading from "../Loading";
import { InputGroup,Label, SubmitBtn } from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";


const EditDetails=({
    onEditBankMutate,
    setEditDetails,
    onEditBankLoading,
    selectedData
})=>{

    const SubmitHandler=(values)=>{
        onEditBankMutate(values);
    }
    const formik= useFormik({
        initialValues:{
            id: selectedData?.id || "",
            bankName: selectedData?.bankName || "",
            accountNum: selectedData?.accountNum || "",
            ifsc: selectedData?.ifsc || "",
            bankAddress: selectedData?.bankAddress || "",
            holderName: selectedData?.holderName || "",
            payuMid: selectedData?.payuMid || "",
            payuKey: selectedData?.payuKey || "",
            isOnlineSettlement: selectedData?.isOnlineSettlement?? "",
        },

        validationSchema: Yup.object().shape({
            bankName:Yup.string().required("Bankname is required"),
            accountNum: Yup.string().required("Account number is required"),
            ifsc:Yup.string().required("Ifsc is required"),
            bankAddress: Yup.string().required("Bank address is required"),
            holderName: Yup.string().required("Holdername is required"),
            payuMid:Yup.string(),
            payuKey: Yup.string(),
            isOnlineSettlement: Yup.number().required("Select the options"),
        }),
        onSubmit:SubmitHandler,
        enableReinitialize:true,
    })
    return(
        <>
        <Model width={`w-11/12 max-w-lg`} setOpenModel={setEditDetails}>
            <Title>Edit Details</Title>
            {onEditBankLoading ? (
                <div className="w-full h-full">
                   <Loading />
                </div>
            ):(
                <form onSubmit={formik.handleSubmit}>
                    <Wrapper>
                        <CombineInputGroup>
                            <InputGroup>
                               <Label htmlFor="holderName">Beneficiary's Name</Label>
                                <FieldWrapper>
                                    <Input
                                    id="holderName"
                                    name="holderName"
                                    value={formik.values.holderName}
                                    onChange={formik.handleChange}
                                    autoComplete="off"
                                    className=""
                                    />
                                    {formik.touched.holderName && formik.errors.holderName &&(
                                        <div className="text-rose-600 text-sm">
                                            {formik.errors.holderName}
                                        </div>
                                    )}
                                </FieldWrapper>
                            </InputGroup>
                            <InputGroup>
                               <Label htmlFor="bankName">Bank Name</Label>
                                <FieldWrapper>
                                    <Input
                                    id="bankName"
                                    name="bankName"
                                    value={formik.values.bankName}
                                    onChange={formik.handleChange}
                                    className=""
                                    autoComplete="off"
                                    />
                                    {formik.touched.bankName && formik.errors.bankName &&(
                                        <div className="text-rose-600 text-sm">
                                            {formik.errors.bankName}
                                        </div>
                                    )}
                                </FieldWrapper>
                            </InputGroup>
                        </CombineInputGroup>

                        <CombineInputGroup>
                            <InputGroup>
                               <Label htmlFor="accountNum">Account Number</Label>
                                <FieldWrapper>
                                    <Input
                                    id="accountNum"
                                    name="accountNum"
                                    value={formik.values.accountNum}
                                    onChange={formik.handleChange}
                                    autoComplete="off"
                                    className=""
                                    />
                                    {formik.touched.accountNum && formik.errors.accountNum &&(
                                        <div className="text-rose-600 text-sm">
                                            {formik.errors.accountNum}
                                        </div>
                                    )}
                                </FieldWrapper>
                            </InputGroup>
                            <InputGroup>
                               <Label htmlFor="ifsc">IFSC</Label>
                                <FieldWrapper>
                                    <Input
                                    id="ifsc"
                                    name="ifsc"
                                    value={formik.values.ifsc}
                                    onChange={formik.handleChange}
                                    autoComplete="off"
                                    className=""
                                    />
                                    {formik.touched.ifsc && formik.errors.ifsc &&(
                                        <div className="text-rose-600 text-sm">
                                            {formik.errors.ifsc}
                                        </div>
                                    )}
                                </FieldWrapper>
                            </InputGroup>
                        </CombineInputGroup>

                        <CombineInputGroup>
                            <InputGroup>
                               <Label htmlFor="payuMid">PayuMid</Label>
                                <FieldWrapper>
                                    <Input
                                    id="payuMid"
                                    name="payuMid"
                                    value={formik.values.payuMid}
                                    onChange={formik.handleChange}
                                    autoComplete="off"
                                    className=""
                                    />
                                    {formik.touched.payuMid && formik.errors.payuMid &&(
                                        <div className="text-rose-600 text-sm">
                                            {formik.errors.payuMid}
                                        </div>
                                    )}
                                </FieldWrapper>
                            </InputGroup>
                            <InputGroup>
                               <Label htmlFor="payuKey">PayuKey</Label>
                                <FieldWrapper>
                                    <Input
                                    id="payuKey"
                                    name="payuKey"
                                    value={formik.values.payuKey}
                                    onChange={formik.handleChange}
                                    autoComplete="off"
                                    className=""
                                    />
                                    {formik.touched.payuKey && formik.errors.payuKey &&(
                                        <div className="text-rose-600 text-sm">
                                            {formik.errors.payuKey}
                                        </div>
                                    )}
                                </FieldWrapper>
                            </InputGroup>
                        </CombineInputGroup>

                        <CombineInputGroup>
                            <InputGroup>
                               <Label htmlFor="bankAddress">Bank Address</Label>
                                <FieldWrapper>
                                    <Input
                                    id="bankAddress"
                                    name="bankAddress"
                                    value={formik.values.bankAddress}
                                    onChange={formik.handleChange}
                                    autoComplete="off"
                                    className=""
                                    />
                                    {formik.touched.bankAddress && formik.errors.bankAddress &&(
                                        <div className="text-rose-600 text-sm">
                                            {formik.errors.bankAddress}
                                        </div>
                                    )}
                                </FieldWrapper>
                            </InputGroup>
                            <InputGroup>
                               <Label htmlFor="isOnlineSettlement">Online Settlement</Label>
                                <FieldWrapper>
                                    <Select
                                    name="isOnlineSettlement"
                                    id="isOnlineSettlement"
                                    value={formik.values.isOnlineSettlement}
                                    onChange={formik.handleChange}
                                    className="w-full pl-2"
                                    style={{ height: "40px" }}
                                    displayEmpty
                                    >   <MenuItem value="" disabled>Select Option</MenuItem>
                                        <MenuItem value={0}>No</MenuItem>
                                        <MenuItem value={1}>Yes</MenuItem>
                                    </Select>
                                    {formik.touched.isOnlineSettlement && formik.errors.isOnlineSettlement &&(
                                        <div className="text-rose-600 text-sm">
                                            {formik.errors.isOnlineSettlement}
                                        </div>
                                    )}
                                </FieldWrapper>
                            </InputGroup>
                        </CombineInputGroup>
                    </Wrapper>
                    <BtnWrapper>
                        <SubmitBtn type="submit">Update</SubmitBtn>
                    </BtnWrapper>
                </form>
            )}
        </Model>
        </>
    )
}
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const CombineInputGroup = tw.div`flex space-x-7`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default EditDetails;